import { useGateValue } from "@statsig/react-bindings";

import { useFeatureFlag } from "@/features/featureFlag";

/**
 * Custom hook to check if LINE channels can be created from the add-channel
 * modal.
 */
export const useEnableLineChannelCreation = (): boolean => {
  const featureFlag = useFeatureFlag("enable-line-channel-creation");
  const featureGate = useGateValue("enable_line_channel_creation");
  return featureFlag || featureGate;
};
